import {BaseCollection} from "../../../collections/_BaseCollection";

export class BaseDataForwardsCollection<TModel extends Backbone.Model> extends BaseCollection<TModel> {
    appUrlRoot = 'dataforwards';
}


// WEBPACK FOOTER //
// ./srv/public/js/apps/dataforwards/collections/_BaseDataForwardsCollection.ts